import React from 'react'
import styled from 'styled-components'
import logo from '../../assets/general/intellicubix-logo.webp';
import IntelliCubixColoredImage from '../../assets/general/intellicubix-colored.png';
import { Link, NavLink as RRNavLink } from 'react-router-dom';
import { FaFacebook, FaLinkedin, FaTiktok } from "react-icons/fa6";
import { CiInstagram } from "react-icons/ci";

const MainContainer = styled.div`
  width: 100%;
  max-width: 1170px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 0 auto;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.black};
  color: #607179;
  padding: 30px 20px 40px 20px;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    flex-direction: column;
    padding-bottom: 10px;
  }
`

const FooterLeft = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    width: 100%;
    align-items: center;
  }
`

const FooterRight = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    width: 100%;
    align-items: center;
  }
`

const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &.right-row {
    justify-content: flex-end;
  }

  .social-links {
    display: flex;
    justify-content: flex-end;
    height: 100%;
    align-items: center;
    width: 270px;
    margin-bottom: -10px;
    margin-right: 10px;
    gap: 40px;

    @media (max-width: ${({ theme }) => theme.screens.tablet}) {
      margin-bottom: -15px;
    }
  }

  ul {
    display: flex;
    gap: 20px;

    li {
      list-style: none;
    }
  }

  @media (max-width: ${({ theme }) => theme.screens.tablet}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;

    ul {
      gap: 10px;
      margin-bottom: 10px;
    }
  }
`

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  width: 100px;
  height: auto;
`;

const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;

  span {
    margin-left: 10px;
    font-size: 18px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.white};
    font-family: ${(props) => props.theme.fonts.headline};
    text-transform: capitalize;
  }
`;

const FooterLink = styled(RRNavLink)`
  text-decoration: none;
  color: #607179;
  font-size: 18px;
  font-weight: 400;
  font-family: ${(props) => props.theme.fonts.body};
  text-transform: capitalize;
  transition: all 0.3s ease;
  font-family: ${(props) => props.theme.fonts.headline};

  &:hover {
    color: ${(props) => props.theme.colors.magenta};
  }
`;

const SocialLink = styled.li`
  color:hsl(199, 11.50%, 42.50%);
  width: ${props => props.height}px;
  height: ${props => props.height}px;
  cursor: pointer;
  
  a {
    transition: all 0.3s ease;
    color:hsl(199, 11.50%, 42.50%);

    &:hover {
        color: ${(props) => props.theme.colors.magenta};
    }
  }

  svg {
    width: 100%;
    height: 100%;
  }
`;

const IntelliCubixColored = styled.img`
  width: 290px;
  height: 49px;
`;

const FooterCopyright = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin: 0 auto;
  color: #607179;
  margin-bottom: 20px;
`;

const FooterCopyrightLeft = styled.div`
  text-align: right;

  a {
    color: ${({ theme }) => theme.colors.magenta};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
  }
`;

const FooterCopyrightRight = styled.div`
  text-align: left;

  a {
    color: ${({ theme }) => theme.colors.magenta};
    text-decoration: none;
  }

  a.privacy-policy {
    text-decoration: none;
    color: #607179;
    font-size: 14px;
    font-weight: 400;
    font-family: ${(props) => props.theme.fonts.body};
    text-transform: capitalize;
    transition: all 0.3s ease;
    font-family: ${(props) => props.theme.fonts.headline};

    &:hover {
        color: ${(props) => props.theme.colors.magenta};
    }
  }
`;

const FooterCopyrightDivider = styled.div`
  width: 1px;
  height: 25px;
  background-color: #607179;
`;

const Footer = () => {
    return (
        <>
            <MainContainer>
                <FooterLeft>
                    <FooterRow>
                        <LogoContainer>
                            <LogoLink to="/">
                                <Logo src={logo} alt="Intellicubix logo" />
                            </LogoLink>
                        </LogoContainer>
                    </FooterRow>
                    <FooterRow>
                        <ul>
                            <li><FooterLink to="/">Home</FooterLink></li>
                            <li><FooterLink to="/services">Services</FooterLink></li>
                            <li><FooterLink to="/blog">Blog</FooterLink></li>
                            <li><FooterLink to="/about">About</FooterLink></li>
                            <li><FooterLink to="/contact">Contact</FooterLink></li>
                        </ul>
                    </FooterRow>
                </FooterLeft>
                <FooterRight>
                    <FooterRow className='right-row'>
                        <ul className='social-links'>
                            <SocialLink height={40}><a href="https://www.linkedin.com/company/intellicubix/" target="_blank"><FaLinkedin /></a></SocialLink>
                            <SocialLink height={35}><a href="https://www.tiktok.com/@intellicubix" target="_blank"><FaTiktok /></a></SocialLink>
                            <SocialLink height={50}><a href="https://www.instagram.com/intellicubix/" target="_blank"><CiInstagram /></a></SocialLink>
                            <SocialLink height={37}><a href="https://www.facebook.com/intellicubix" target="_blank"><FaFacebook /></a></SocialLink>
                        </ul>
                    </FooterRow>
                    <FooterRow className='right-row'>
                        <IntelliCubixColored src={IntelliCubixColoredImage} alt="Intellicubix Colored" />
                    </FooterRow>
                </FooterRight>
            </MainContainer>
            <FooterCopyright>
                <FooterCopyrightLeft>
                    <p>© 2025 <a href="/">INTELLICUBIX</a></p>
                </FooterCopyrightLeft>
                <FooterCopyrightDivider />
                <FooterCopyrightRight>
                    <FooterLink className='privacy-policy' to="/privacy-policy">PRIVACY POLICY</FooterLink>
                </FooterCopyrightRight>
            </FooterCopyright>
        </>
    )
}

export default Footer